import {Button} from "@chakra-ui/button"
import React, { useState } from 'react'
import {FormControl, FormLabel, Input, InputGroup, InputRightElement, VStack} from "@chakra-ui/react";
import { useToast } from '@chakra-ui/react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../config/Baseurl";
const Login = () => {
  const [show,setShow]=useState(false);
  const [email,setEmail]=useState();
  const [password,setPassword]=useState();
  const [loading,setLoading]=useState(false);
  const navigate=useNavigate();
  const toast=useToast();

  const handleclick=()=>{
    setShow(!show);
  }

  const submitHandler=async ()=>{
      setLoading(true);
      if(!email || !password){
        toast({
          title: 'Please fill all the fields',
          status: 'Warning',
          duration: 5000,
          isClosable: true,
          position:"top",
        });
        setLoading(false);
        return;
      }
      
      try {
        const config={
          hraders:{
            "Content-type":"application/json",
          },
        };

        const {data}=await axios.post(`${BaseUrl}user/login`,
         {email,password},config
        );
        if(data.message==='user not found'){
          toast({
            title: data.message,
            status: 'warning',
            duration: 5000,
            isClosable: true,
            position:"top",
          });
        }
        else if(data.message==="Invalid Email or Password"){
          toast({
            title: data.message,
            status: 'warning',
            duration: 5000,
            isClosable: true,
            position:"top",
          });          
        }
        else{
        toast({
          title: 'Login Successful',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position:"top",
        });
        navigate("/chat");
      }
        localStorage.setItem("userinfo",JSON.stringify(data));
        setLoading(false);

      } catch (error) {
        toast({
          title: 'Error occured',
          description:error.response.data.message,
          status: 'Error',
          duration: 5000,
          isClosable: true,
          position:"top",
        });
        setLoading(false);
      }
  }
  return (
    <VStack spacing="5px">

    <FormControl  id='email' isRequired>
     <FormLabel>Email</FormLabel>
     <Input value={email} placeholder='Enter Your Email' onChange={(e)=>setEmail(e.target.value)}/>
    </FormControl>

    <FormControl  id='password' isRequired>
     <FormLabel>Password</FormLabel>
     <InputGroup>
     <Input value={password} type={show?"text":"password"} placeholder='Enter Your Password' onChange={(e)=>setPassword(e.target.value)}/>
     <InputRightElement width="4.5rem">
      <Button h="1.75rem" size="sm" onClick={handleclick}>
        {show?"Hide":"Show"}
      </Button>
     </InputRightElement>
     </InputGroup>
    </FormControl>

    <Button
      colorScheme="blue"
      width="100%"
      style={{ marginTop: 15 }}
      onClick={submitHandler}
      isLoading={loading}
    >Login</Button>
    
    <Button
        variant="solid"
        colorScheme="red"
        width="100%"
        onClick={() => {
          setEmail("guest@example.com");
          setPassword("123456");
        }}
      >
        Get Guest User Credentials
      </Button>
    </VStack>
)
}

export default Login;
